import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { APPLICATION_ROLES } from './core/consts/application-roles';

const { scaniaIt, admin, inspector } = APPLICATION_ROLES;

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/home/home').then((m) => m.Home),
  },
  {
    path: 'checklist/templates',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/checklists/templates/pages/checklist-template-list-page/checklist-template-list-page').then(
        (m) => m.ChecklistTemplateListPage,
      ),
  },
  {
    path: 'checklist/templates/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/checklists/templates/pages/checklist-template-editor-page/checklist-template-editor-page').then(
        (m) => m.ChecklistTemplateEditorPage,
      ),
  },
  {
    path: 'checklist/templates/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/checklists/templates/pages/checklist-template-editor-page/checklist-template-editor-page').then(
        (m) => m.ChecklistTemplateEditorPage,
      ),
  },
  {
    path: 'inspection',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin, inspector] },
    loadComponent: () =>
      import('./features/inspection/pages/inspection-workspace-page/inspection-workspace-page').then(
        (m) => m.InspectionWorkspacePage,
      ),
  },
  {
    path: 'inspection/run',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin, inspector] },
    loadComponent: () =>
      import('./features/inspection/pages/inspection-runner-page/inspection-runner-page').then(
        (m) => m.InspectionRunnerPage,
      ),
  },
  {
    path: 'inspection/history',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin, inspector] },
    loadComponent: () =>
      import('./features/inspection/pages/inspection-history-page/inspection-history-page').then(
        (m) => m.InspectionHistoryPage,
      ),
  },
  {
    path: 'inspection/history/:id',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin, inspector] },
    loadComponent: () =>
      import('./features/inspection/pages/inspection-history-view-page/inspection-history-view-page').then(
        (m) => m.InspectionHistoryViewPage,
      ),
  },
  {
    path: 'checklist/reports',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin, inspector] },
    loadComponent: () => import('./features/checklists/reports/reports').then((m) => m.Reports),
  },
  {
    path: 'register/company',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/companies/pages/company-list-page/company-list-page').then(
        (m) => m.CompanyListPage,
      ),
  },
  {
    path: 'register/company/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/companies/pages/company-editor-page/company-editor-page').then(
        (m) => m.CompanyEditorPage,
      ),
  },
  {
    path: 'register/company/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/companies/pages/company-editor-page/company-editor-page').then(
        (m) => m.CompanyEditorPage,
      ),
  },
  {
    path: 'register/person',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/persons/pages/person-list-page/person-list-page').then(
        (m) => m.PersonListPage,
      ),
  },
  {
    path: 'register/person/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/persons/pages/person-editor-page/person-editor-page').then(
        (m) => m.PersonEditorPage,
      ),
  },
  {
    path: 'register/person/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/persons/pages/person-editor-page/person-editor-page').then(
        (m) => m.PersonEditorPage,
      ),
  },
  {
    path: 'register/position',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/positions/pages/position-list-page/position-list-page').then(
        (m) => m.PositionListPage,
      ),
  },
  {
    path: 'register/position/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/positions/pages/position-editor-page/position-editor-page').then(
        (m) => m.PositionEditorPage,
      ),
  },
  {
    path: 'register/position/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/positions/pages/position-editor-page/position-editor-page').then(
        (m) => m.PositionEditorPage,
      ),
  },
  {
    path: 'register/document-type',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/document-types/pages/document-type-list-page/document-type-list-page').then(
        (m) => m.DocumentTypeListPage,
      ),
  },
  {
    path: 'register/document-type/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/document-types/pages/document-type-editor-page/document-type-editor-page').then(
        (m) => m.DocumentTypeEditorPage,
      ),
  },
  {
    path: 'register/document-type/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt, admin] },
    loadComponent: () =>
      import('./features/register/document-types/pages/document-type-editor-page/document-type-editor-page').then(
        (m) => m.DocumentTypeEditorPage,
      ),
  },
  {
    path: 'admin/area',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/areas/pages/area-list-page/area-list-page').then(
        (m) => m.AreaListPage,
      ),
  },
  {
    path: 'admin/area/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/areas/pages/area-editor-page/area-editor-page').then(
        (m) => m.AreaEditorPage,
      ),
  },
  {
    path: 'admin/area/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/areas/pages/area-editor-page/area-editor-page').then(
        (m) => m.AreaEditorPage,
      ),
  },
  {
    path: 'admin/banner',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/banners/pages/banner-list-page/banner-list-page').then(
        (m) => m.BannerListPage,
      ),
  },
  {
    path: 'admin/banner/new',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/banners/pages/banner-editor-page/banner-editor-page').then(
        (m) => m.BannerEditorPage,
      ),
  },
  {
    path: 'admin/banner/:id/edit',
    canActivate: [authGuard],
    data: { roles: [scaniaIt] },
    loadComponent: () =>
      import('./features/admin/banners/pages/banner-editor-page/banner-editor-page').then(
        (m) => m.BannerEditorPage,
      ),
  },
  {
    path: 'faq',
    canActivate: [authGuard],
    loadComponent: () => import('./features/help/faq/faq').then((m) => m.Faq),
  },
  {
    path: 'tutorial',
    canActivate: [authGuard],
    loadComponent: () => import('./features/help/tutorial/tutorial').then((m) => m.Tutorial),
  },
  {
    path: 'forbidden',
    canActivate: [authGuard],
    loadComponent: () => import('./features/forbidden/forbidden').then((m) => m.Forbidden),
  },
  { path: '**', redirectTo: '' },
];
